(function () {
  function initSwiper(el) {
    if (el.swiper) {
      el.swiper.destroy(true, true);
    }
    var config = {};
    try {
      config = JSON.parse(el.dataset.swiperConfig || '{}');
    } catch (e) {
      config = {};
    }
    el.swiper = new Swiper(el, config);
  }

  function initAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-swiper').forEach(initSwiper);
  }

  function destroyAll(root) {
    var scope = root || document;
    scope.querySelectorAll('.js-swiper').forEach(function (el) {
      if (el.swiper) {
        el.swiper.destroy(true, true);
        el.swiper = null;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    destroyAll(event.target);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var swiperEl = event.target.closest('.js-swiper');
    if (swiperEl && swiperEl.swiper) {
      var slide = event.target.closest('.swiper-slide');
      if (slide) {
        var index = Array.prototype.indexOf.call(swiperEl.querySelectorAll('.swiper-slide'), slide);
        if (index > -1) swiperEl.swiper.slideTo(index);
      }
      swiperEl.swiper.autoplay && swiperEl.swiper.autoplay.stop();
    }
  });

  document.addEventListener('shopify:block:deselect', function (event) {
    var swiperEl = event.target.closest('.js-swiper');
    if (swiperEl && swiperEl.swiper && swiperEl.swiper.params.autoplay) {
      swiperEl.swiper.autoplay && swiperEl.swiper.autoplay.start();
    }
  });
})();
